import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientMDQForm() {
    return (
        <PatientFormTemplate formTitle="Mood Disorder Questionnaire (MDQ)" />
    );
}
